'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Divider = require('@narvar/nth-bit-divider');
var Paragraph = require('@narvar/nth-bit-paragraph');
var TextLink = require('@narvar/nth-bit-text-link');
var TelephoneInput = require('@narvar/nth-block-telephone-input');
var mustache = require('mustache');
var Button = require('@narvar/nth-block-button');
var DisclaimerText = require('@narvar/nth-block-notification-center-disclaimer-text');
var phone = require('phone');
var libphonenumberJs = require('libphonenumber-js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Spinner = require('@narvar/nth-bit-icon-spinner');
var MustacheNestedRender = require('@narvar/nth-bit-mustache-nested-render');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var TemplateLinkContext = require('../../common/TemplateLinkContext.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Subscribed_module = require('./Subscribed.module.css.js');
var nthHookGrowthbook = require('@narvar/nth-hook-growthbook');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var TelephoneInput__default = /*#__PURE__*/_interopDefaultLegacy(TelephoneInput);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var DisclaimerText__default = /*#__PURE__*/_interopDefaultLegacy(DisclaimerText);
var phone__default = /*#__PURE__*/_interopDefaultLegacy(phone);
var Spinner__default = /*#__PURE__*/_interopDefaultLegacy(Spinner);
var MustacheNestedRender__default = /*#__PURE__*/_interopDefaultLegacy(MustacheNestedRender);

const Subscribed = ({
  featureName,
  isLandscape,
  validationError = false,
  contact,
  cprefOptedIn,
  cprefSubscribed,
  marketingSubscribed,
  showContactInput,
  subscribing,
  unsubscribing,
  narvarProfileUrl,
  onTelephoneInputChange,
  onMarketingOptinSubmit,
  onMarketingOptout
}) => {
  const [userSubmittedContact, setUserSubmittedContact] = React.useState(contact);
  const {
    retailerName
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    notificationCenter
  } = nthHookSettings.useSettings();
  const {
    enabled: trackOnlyOptinEnabled
  } = nthHookGrowthbook.useIsTrackFeatureOn('track-only-optin');
  const {
    marketingOptInPrivacyLink,
    marketingOptInTermsLink
  } = notificationCenter ?? {};
  const {
    notificationCenterSublimeAutoOptinTitle,
    notificationCenterSublimeAutoOptinText,
    notificationCenterSublimeManageYourPreferences,
    notificationCenterSmsSignupButton,
    notificationCenterSmsOptoutLink,
    notificationCenterMarketingOptInText,
    notificationCenterSmsInputLabel,
    notificationCenterSmsValidationErrorMessage,
    notificationCenterSmsUpdateNumberMessage
  } = nthHookTranslations.useTranslations();

  // Temp translations
  const notificationCenterSmsMarketingOptinTitle = 'Get the Latest Updates';
  const notificationCenterSublimeConfirmHeading = 'Confirm Your Phone Number';
  const notificationCenterSublimeConfirmText = 'Reply “Y” to the message sent to the number you provided to complete your opt-in and receive updates on all of your orders.';
  const {
    bodytextDefaultNone: bodyTextStyle,
    captiontextErrorNone: errorTextStyle,
    linksNoneDefault: linkStyle,
    linksNoneHover: linkHoverStyle
  } = nthHookTheme.useTheme();
  const formattedPhoneNumber = React.useMemo(() => {
    if (!contact) return;
    const {
      phoneNumber: parsablePhoneNumber
    } = phone__default["default"](contact ?? '');
    const phoneNumber = libphonenumberJs.parsePhoneNumber(parsablePhoneNumber ?? '');
    return phoneNumber.formatNational();
  }, [contact]);
  const handleManagePreferencesClick = () => {
    window.open(`${narvarProfileUrl}/login?type=phone`);
  };
  const handleTelephoneInputChange = contact => {
    setUserSubmittedContact(contact);
    onTelephoneInputChange(contact);
  };
  const handleMarketingOptout = () => {
    onMarketingOptout();
  };
  const handleMarketingOptinSubmit = () => {
    if (!userSubmittedContact) return;
    onMarketingOptinSubmit(userSubmittedContact);
  };
  return /*#__PURE__*/React__default["default"].createElement("div", null, (cprefOptedIn || cprefSubscribed) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h3"
  }, trackOnlyOptinEnabled && !cprefSubscribed ? notificationCenterSublimeConfirmHeading : notificationCenterSublimeAutoOptinTitle), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, trackOnlyOptinEnabled && !cprefSubscribed ? notificationCenterSublimeConfirmText : notificationCenterSublimeAutoOptinText), /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: linkStyle,
      sHover: linkHoverStyle
    },
    onClick: handleManagePreferencesClick
  }, notificationCenterSublimeManageYourPreferences)), !cprefOptedIn && !cprefSubscribed && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h3"
  }, notificationCenterSmsUpdateNumberMessage), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Subscribed_module["default"].unsubscribeButtonContainer
  }, unsubscribing ? /*#__PURE__*/React__default["default"].createElement(Spinner__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: linkStyle,
      sHover: linkHoverStyle
    },
    onClick: handleMarketingOptout
  }, notificationCenterSmsOptoutLink))), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), (!marketingSubscribed || showContactInput) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h3"
  }, notificationCenterSmsMarketingOptinTitle), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, /*#__PURE__*/React__default["default"].createElement(MustacheNestedRender__default["default"], {
    template: mustache__default["default"].parse(notificationCenterMarketingOptInText || ''),
    context: new mustache__default["default"].Context({
      retailerName,
      privacyLink: () => TemplateLinkContext.templateLinkContext(marketingOptInPrivacyLink || '', linkStyle, linkHoverStyle),
      termsLink: () => TemplateLinkContext.templateLinkContext(marketingOptInTermsLink || '', linkStyle, linkHoverStyle)
    })
  })), contact && !showContactInput ? /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    featureName: featureName
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: 'gray'
    }
  }, formattedPhoneNumber)) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(TelephoneInput__default["default"], {
    label: notificationCenterSmsInputLabel ?? '',
    title: notificationCenterSmsInputLabel ?? '',
    centered: !isLandscape,
    error: false,
    featureName: featureName,
    disabled: subscribing,
    onChangeCallback: handleTelephoneInputChange,
    s: validationError ? {
      border: `1px solid ${errorTextStyle?.color ?? ''}`
    } : undefined
  }), validationError && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...bodyTextStyle,
      ...errorTextStyle
    }
  }, notificationCenterSmsValidationErrorMessage)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Subscribed_module["default"].buttonContainer
  }, subscribing ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: Subscribed_module["default"].spinnerContainer
  }, /*#__PURE__*/React__default["default"].createElement(Spinner__default["default"], null)) : /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    featureName: featureName,
    big: true,
    type: Button.ButtonType.submit,
    onClick: handleMarketingOptinSubmit
  }, notificationCenterSmsSignupButton)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Subscribed_module["default"].disclaimerContainer
  }, /*#__PURE__*/React__default["default"].createElement(DisclaimerText__default["default"], {
    featureName: featureName,
    notificationChannel: 'sms'
  }))), marketingSubscribed && !showContactInput && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h3"
  }, notificationCenterSmsUpdateNumberMessage), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Subscribed_module["default"].unsubscribeButtonContainer
  }, unsubscribing ? /*#__PURE__*/React__default["default"].createElement(Spinner__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: linkStyle,
      sHover: linkHoverStyle
    },
    onClick: handleMarketingOptout
  }, notificationCenterSmsOptoutLink))));
};
const translationsProvider = component => nthHookTranslations.withTranslationsProvider(component, {
  translationKeys: ['notificationCenterSublimeAutoOptinTitle', 'notificationCenterSublimeAutoOptinText', 'notificationCenterSublimeManageYourPreferences', 'notificationCenterSmsSignupButton', 'notificationCenterSmsOptoutLink', 'notificationCenterMarketingOptInText', 'notificationCenterSmsInputLabel', 'notificationCenterSmsValidationErrorMessage', 'notificationCenterSmsUpdateNumberMessage']
});
const globalSettingsProvider = component => nthHookGlobalSettings.withGlobalSettingsProvider(component, {
  globalSettingsRequested: `
      retailerName
    `
});
const settingsProvider = component => nthHookSettings.withSettingsProvider(component, {
  settingsRequested: `
      notificationCenter {
        marketingOptInPrivacyLink
        marketingOptInTermsLink
      }
    `
});
const themeProvider = component => nthHookTheme.withThemeProvider(component, {
  themeTokens: ['bodytextDefaultNone', 'captiontextErrorNone', 'linksNoneDefault', 'linksNoneHover']
});
var Subscribed$1 = translationsProvider(globalSettingsProvider(settingsProvider(themeProvider(Subscribed))));

exports["default"] = Subscribed$1;
